import { configureStore } from '@reduxjs/toolkit';
import accountSlice from './accountSlice';
import orgSlice from './orgSlice';
import inventorySlice from './inventorySlice';
import payrollSlice from './payrollSlice';

export const store = configureStore({
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: false, // Disable serializable state check
      }),
    reducer: {
      accounts: accountSlice,
      software: orgSlice,
      inventory: inventorySlice,
      payroll: payrollSlice
    },
  });
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
